import React from 'react';
import { WORK_PAGE_TYPE } from '../../../../constants';
import {
  ProductPurchaseDetails,
  ProductPurchasingController,
} from '../../../../types/Purchasing';
import { EnquireButton } from '../EnquireButton';

type Props<T extends ProductPurchaseDetails> = {
  product: ProductType;
  purchasingController: ProductPurchasingController<T>;
};

export const PrivateSubscriptionCta: React.FC<
  Props<ProductPurchaseDetails>
> = ({ product, purchasingController }) => {
  return (
    <EnquireButton
      analytics={{
        page: WORK_PAGE_TYPE,
        pageTitle: product.title,
        context: 'enquire now',
      }}
      product={product}
      purchasingController={purchasingController}
    />
  );
};
